import * as React from "react";
import { UseFormReturn } from "react-hook-form";

import ButtonLoader from "@/components/shared/button-loader";
import { ExpressInterestFormValues } from "@/components/shared/buttons/express-interest-button/express-interest-modal/express-interest-form-schema";
import FormRootError from "@/components/shared/form/form-root-error";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";

export function ExpressInterestFormView({
  form,
  onCancel,
  onSubmit,
}: {
  form: UseFormReturn<ExpressInterestFormValues>;
  onSubmit: () => void;
  onCancel: () => void;
}) {
  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="flex min-w-0 flex-col gap-4">
        <div className="flex flex-col gap-2">
          <FormField
            control={form.control}
            name="message"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Textarea
                    placeholder="Optional message — we recommend suggesting times to connect."
                    className="text-sm placeholder:text-xs min-h-[80px] shadow-none"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="bg-surface-subtle rounded-md px-3 py-3">
          <p className="text-[11px] font-semibold text-ink-faint uppercase tracking-wide mb-2">
            What happens next
          </p>
          <ol className="text-xs text-ink-subtle space-y-1.5">
            <li className="flex items-start gap-2">
              <span className="text-ink-faint font-medium">1.</span>
              <span>
                We&apos;ll reach out to the principal with your message and
                profile
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-ink-faint font-medium">2.</span>
              <span>Once they respond, you&apos;ll get a notification</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-ink-faint font-medium">3.</span>
              <span>Check your Connections tab and email for their reply</span>
            </li>
          </ol>
        </div>

        <FormRootError />

        <div className="flex flex-row gap-2 pt-2 border-t border-border">
          <Button
            type="button"
            onClick={onCancel}
            variant="outline"
            disabled={form.formState.isSubmitting}
            className="flex-1 shadow-none"
          >
            Cancel
          </Button>
          <ButtonLoader
            type="submit"
            disabled={form.formState.isSubmitting}
            loading={form.formState.isSubmitting}
            className="flex-1 bg-surface-inverted hover:bg-surface-inverted/90 shadow-none"
          >
            Send message
          </ButtonLoader>
        </div>
      </form>
    </Form>
  );
}
